<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">本SA変更・取消詳細</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="$router.go(-1)">戻る</v-btn>
        <v-btn
          @click="mergeSa"
          v-if="$route.query.status === 'CONFLICT'"
          v-permit.SHARP_PSCD_CONFLICT
          >本SA書換</v-btn
        >
        <v-btn
          @click="cancelSa"
          v-if="
            $route.query.status === 'CANCEL' &&
              ($route.query.type === 'CANCEL' || $route.query.type === 'BOTH')
          "
          v-permit.SHARP_PSCD_SA_CANCEL
          >登録済みSA取消</v-btn
        >
        <v-btn
          v-if="$route.query.type === 'REMOVE' || $route.query.type === 'BOTH'"
          @click="recoverySa()"
          >変更・取消データ</v-btn
        >
      </v-card-actions>
    </v-card>
    <sa-detail :id="$route.query.id" class="mt-2" />
    <!-- <sa-detail :conflictId="$route.query.id" class="mt-2" /> -->
    <do-list :id="$route.query.id" class="mt-2"></do-list>
  </v-container>
</template>
<script>
import SaDetail from './SaDetail'
import DoList from './DoList'
export default {
  components: { SaDetail, DoList },
  data() {
    return {
      form: {},
      headers: [],
      results: [],
      selected: [],
      loading: false,
      pagination: {
        rowsPerPage: 10,
      },
      errors: {
        INVALID_STATUS: 'D/O取消してください。',
        PACKAGE_QTY_OVER: 'POの発注数量を超えてしまう、ご確認ください。',
        INVALID_INV_STATUS: 'I/V取消してください',
      },
    }
  },
  methods: {
    cancelSa() {
      this.$confirm({
        title: 'ポップアップ',
        content: '当該SAを取り消しますか。ご確認お願いします。',
        action: 'はい',
        rejectAction: 'いいえ',
      }).then(() => {
        this.$http
          .put(`/shipping-advices/cancel?formalSaId=${this.$route.query.id}`)
          .then(() => {
            this.$message('', 'SUCCESS')
          })
          .catch(() => {
            this.showError(res)
          })
      })
    },
    mergeSa() {
      this.$http
        .post(`shipping-advices/merge-sa`, {
          preSaId: this.$route.query.preSaId,
          formalSaId: this.$route.query.formalSaId,
        })
        .then(() => {
          this.$message('', 'SA替换成功')
        })
        .catch((res) => {
          this.showError(res)
        })
    },
    showError(res) {
      if (this.errors[res.response.data.message]) {
        this.$message(
          this.$t('app.messages.errors.title'),
          this.errors[res.response.data.message]
        )
      } else {
        this.$message(this.$t('app.messages.errors.title'), 'System Error.')
      }
    },
    recoverySa() {
      this.$confirm({
        title: 'ポップアップ',
        content: '当該CANCELデータを削除しますか。ご確認お願いします。',
        action: 'はい',
        rejectAction: 'いいえ',
      }).then(() => {
        this.$http
          .patch(`/shipping-advices/${this.$route.query.id}/recovery`)
          .then(() => {
            this.$message('', 'SUCCESS')
          })
          .catch(() => {
            this.$message('', 'ERROR')
          })
      })
    },
  },
}
</script>
